export default {
  projects: [],
  project: {
    id: null,
    images: [],
    nombre: null,
    descripcion: null,
    tecnologias: null,
    visible: false
  },
  defaultProject: {
    id: null,
    images: [],
    nombre: null,
    descripcion: null,
    tecnologias: null,
    visible: false
  },
  projectDeletionPending: [],
  projectCreationPending: false
}
